module.exports = __webpack_public_path__ + "static/43import-cbfdf54415b8a8d11ef66caac17661b7.png";